<div class="theme-page-shell" [testId]="'servicenumber-theme-card'">
  <div class="page-topbar">
    <div class="card-header" [testId]="'servicenumber-theme-header'">
      <div class="page-heading">
        <h3 class="page-title" [testId]="'servicenumber-theme-title'">{{ 'servicenumber.theme.title' | i18n }}</h3>
      </div>
      <div class="card-actions" [testId]="'servicenumber-theme-actions'">
        <button
          nz-button
          class="save-action"
          [nzType]="hasUnsavedChanges ? 'primary' : 'default'"
          (click)="save()"
          [nzLoading]="saving"
          [disabled]="!hasUnsavedChanges"
          [testId]="'save-theme-button'"
        >
          <i nz-icon nzType="save"></i>
          <span>{{ 'common.save' | i18n }}</span>
        </button>
      </div>
    </div>

    <div class="draft-banner" *ngIf="hasUnsavedChanges">
      <i nz-icon nzType="exclamation-circle" nzTheme="fill" class="draft-banner-icon"></i>
      <span class="draft-banner-text">{{ 'servicenumber.config.unsaved-banner' | i18n }}</span>
    </div>
  </div>

  <div class="theme-page-surface">
    <div class="editor-layout">
      <div class="form-column">
        <div class="form-scroll">
          <form nz-form [formGroup]="configForm" class="form" testId="servicenumber-theme-form">
            <div class="section-card">
              <h3 class="section-title">{{ 'theme.item.system-theme.title' | i18n }}</h3>
              <div nz-form-item class="span-2">
                <div nz-form-control class="theme-selector">
                  <nz-select
                    class="theme-full-select"
                    [(ngModel)]="selectedThemeId"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onThemeSelected($event)"
                    name="selectedThemeId"
                    [nzPlaceHolder]="'theme.item.system-theme.placeholder' | i18n"
                    testId="servicenumber-theme-system-theme-select"
                  >
                    <nz-option *ngFor="let opt of themeOptions" [nzValue]="opt.id" [nzLabel]="opt.name" />
                  </nz-select>
                  <div class="selector-desc">{{ 'theme.item.system-theme.desc' | i18n }}</div>
                  <div class="theme-palette-strip">
                    <div class="theme-palette-chip">
                      <span class="swatch" [style.background]="configForm.value.primaryColor"></span>
                      <span class="label">{{ 'theme.item.field.primary-color' | i18n }}</span>
                    </div>
                    <div class="theme-palette-chip">
                      <span class="swatch" [style.background]="configForm.value.backgroundColor"></span>
                      <span class="label">{{ 'theme.item.field.background-color' | i18n }}</span>
                    </div>
                    <div class="theme-palette-chip">
                      <span class="swatch" [style.background]="configForm.value.headerTextColor"></span>
                      <span class="label">{{ 'theme.item.field.header-text-color' | i18n }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="section-card">
              <h3 class="section-title">{{ 'theme.item.section.base-colors' | i18n }}</h3>
              <div class="grid two">
                <div nz-form-item>
                  <div nz-form-label>
                    <label>{{ 'theme.item.field.primary-color' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input type="color" formControlName="primaryColor" testId="servicenumber-theme-primary-color-picker" />
                      <input nz-input id="primaryColor" formControlName="primaryColor" testId="servicenumber-theme-primary-color-input" />
                    </div>
                  </div>
                </div>
                <div nz-form-item>
                  <div nz-form-label>
                    <label>{{ 'theme.item.field.background-color' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input type="color" formControlName="backgroundColor" testId="servicenumber-theme-background-color-picker" />
                      <input
                        nz-input
                        id="backgroundColor"
                        formControlName="backgroundColor"
                        testId="servicenumber-theme-background-color-input"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="section-card">
              <h3 class="section-title">{{ 'theme.item.section.bubbles' | i18n }}</h3>
              <div class="grid two">
                <div nz-form-item>
                  <div nz-form-label>
                    <label>{{ 'theme.item.field.user-message-bg' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input type="color" formControlName="customerBubbleBg" testId="servicenumber-theme-customer-bubble-bg-picker" />
                      <input
                        nz-input
                        id="customerBubbleBg"
                        formControlName="customerBubbleBg"
                        testId="servicenumber-theme-customer-bubble-bg-input"
                      />
                    </div>
                  </div>
                </div>
                <div nz-form-item>
                  <div nz-form-label>
                    <label>{{ 'theme.item.field.user-message-text' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input type="color" formControlName="customerBubbleText" testId="servicenumber-theme-customer-bubble-text-picker" />
                      <input
                        nz-input
                        id="customerBubbleText"
                        formControlName="customerBubbleText"
                        testId="servicenumber-theme-customer-bubble-text-input"
                      />
                    </div>
                  </div>
                </div>
                <div nz-form-item>
                  <div nz-form-label>
                    <label>{{ 'theme.item.field.service-message-bg' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input type="color" formControlName="agentBubbleBg" testId="servicenumber-theme-agent-bubble-bg-picker" />
                      <input
                        nz-input
                        id="agentBubbleBg"
                        formControlName="agentBubbleBg"
                        testId="servicenumber-theme-agent-bubble-bg-input"
                      />
                    </div>
                  </div>
                </div>
                <div nz-form-item>
                  <div nz-form-label>
                    <label>{{ 'theme.item.field.service-message-text' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input type="color" formControlName="agentBubbleText" testId="servicenumber-theme-agent-bubble-text-picker" />
                      <input
                        nz-input
                        id="agentBubbleText"
                        formControlName="agentBubbleText"
                        testId="servicenumber-theme-agent-bubble-text-input"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <details class="theme-advanced">
              <summary class="theme-advanced-summary">
                <div>
                  <div class="theme-advanced-title">{{ 'theme.item.advanced.title' | i18n }}</div>
                  <div class="theme-advanced-desc">{{ 'theme.item.advanced.desc' | i18n }}</div>
                </div>
                <span class="theme-advanced-toggle"></span>
              </summary>

              <div class="theme-advanced-content">
                <div class="section-card">
                  <h3 class="section-title">{{ 'theme.item.section.ui-elements' | i18n }}</h3>
                  <div class="grid two">
                    <div nz-form-item>
                      <div nz-form-label>
                        <label>{{ 'theme.item.field.header-bg' | i18n }}</label>
                      </div>
                      <div nz-form-control>
                        <div class="color-input-pair">
                          <input type="color" formControlName="headerBg" testId="servicenumber-theme-header-bg-picker" />
                          <input nz-input id="headerBg" formControlName="headerBg" testId="servicenumber-theme-header-bg-input" />
                        </div>
                      </div>
                    </div>
                    <div nz-form-item>
                      <div nz-form-label>
                        <label>{{ 'theme.item.field.header-text-color' | i18n }}</label>
                      </div>
                      <div nz-form-control>
                        <div class="color-input-pair">
                          <input type="color" formControlName="headerTextColor" testId="servicenumber-theme-header-text-color-picker" />
                          <input
                            nz-input
                            id="headerTextColor"
                            formControlName="headerTextColor"
                            testId="servicenumber-theme-header-text-color-input"
                          />
                        </div>
                      </div>
                    </div>
                    <div nz-form-item>
                      <div nz-form-label>
                        <label>{{ 'theme.item.field.footer-bg' | i18n }}</label>
                      </div>
                      <div nz-form-control>
                        <div class="color-input-pair">
                          <input type="color" formControlName="footerBg" testId="servicenumber-theme-footer-bg-picker" />
                          <input nz-input id="footerBg" formControlName="footerBg" testId="servicenumber-theme-footer-bg-input" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="section-card">
                  <h3 class="section-title">{{ 'theme.item.section.radius-shadow' | i18n }}</h3>
                  <div class="grid two">
                    <div nz-form-item>
                      <div nz-form-label>
                        <label>{{ 'theme.item.field.bubble-radius' | i18n }}</label>
                      </div>
                      <div nz-form-control>
                        <input nz-input id="bubbleRadius" formControlName="bubbleRadius" testId="servicenumber-theme-bubble-radius-input" />
                      </div>
                    </div>
                    <div nz-form-item>
                      <div nz-form-label>
                        <label>{{ 'theme.item.field.window-radius' | i18n }}</label>
                      </div>
                      <div nz-form-control>
                        <input nz-input id="windowRadius" formControlName="windowRadius" testId="servicenumber-theme-window-radius-input" />
                      </div>
                    </div>
                    <div nz-form-item class="span-2">
                      <div nz-form-label>
                        <label>{{ 'theme.item.shadow.title' | i18n }}</label>
                      </div>
                      <div nz-form-control>
                        <nz-select
                          [(ngModel)]="shadowPreset"
                          name="shadowPreset"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="onShadowPresetChange($event)"
                          style="width: 100%"
                          testId="servicenumber-theme-shadow-preset-select"
                        >
                          <nz-option [nzLabel]="'theme.item.shadow.preset.none' | i18n" nzValue="none" />
                          <nz-option [nzLabel]="'theme.item.shadow.preset.light' | i18n" nzValue="light" />
                          <nz-option [nzLabel]="'theme.item.shadow.preset.standard' | i18n" nzValue="standard" />
                          <nz-option [nzLabel]="'theme.item.shadow.preset.deep' | i18n" nzValue="deep" />
                          <nz-option [nzLabel]="'theme.item.shadow.preset.custom' | i18n" nzValue="custom" />
                        </nz-select>
                      </div>
                    </div>
                    <div nz-form-item class="span-2" *ngIf="shadowPreset === 'custom'">
                      <div nz-form-label>
                        <label>{{ 'theme.item.shadow.custom-placeholder' | i18n }}</label>
                      </div>
                      <div nz-form-control>
                        <input
                          nz-input
                          class="full-width-input theme-muted-input"
                          [(ngModel)]="shadowCustomValue"
                          name="shadowCustomValue"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="onShadowCustomValueChange($event)"
                          [placeholder]="'theme.item.shadow.custom-placeholder' | i18n"
                          style="background: #f3f3f5"
                          testId="servicenumber-theme-shadow-custom-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="section-card">
                  <h3 class="section-title">{{ 'theme.item.font.title' | i18n }}</h3>
                  <div class="grid two">
                    <div nz-form-item>
                      <div nz-form-label>
                        <label>{{ 'theme.item.font.size.message' | i18n }}</label>
                      </div>
                      <div nz-form-control>
                        <input
                          nz-input
                          id="fontSizeBase"
                          formControlName="fontSizeBase"
                          testId="servicenumber-theme-font-size-base-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </details>
          </form>
        </div>
      </div>

      <div class="preview-column">
        <div class="section-card preview-card">
          <h3 class="section-title">{{ 'theme.item.preview.title' | i18n }}</h3>
          <div
            class="chat-preview"
            [style.background]="configForm.value.backgroundColor"
            [style.box-shadow]="configForm.get('boxShadowMedium')?.value"
            [style.border-radius]="configForm.value.windowRadius"
            [style.--preview-primary-color]="configForm.value.primaryColor"
          >
            <div class="chat-header" [style.background]="configForm.value.headerBg" [style.color]="configForm.value.headerTextColor">
              <span class="avatar"></span>
              <div class="header-info">
                <div class="name">{{ 'theme.item.preview.header' | i18n }}</div>
                <div class="status">{{ 'theme.item.preview.status.online' | i18n }}</div>
              </div>
            </div>
            <div class="chat-messages">
              <div class="message-row service">
                <span class="avatar"></span>
                <div
                  class="message service"
                  [style.background]="configForm.value.agentBubbleBg"
                  [style.color]="configForm.value.agentBubbleText"
                  [style.border-radius]="configForm.value.bubbleRadius"
                  [style.box-shadow]="configForm.get('boxShadowMedium')?.value"
                  [style.font-size]="configForm.value.fontSizeBase"
                >
                  {{ 'theme.item.preview.service-message.example' | i18n }}
                </div>
              </div>
              <div class="message-row user">
                <div
                  class="message user"
                  [style.background]="configForm.value.customerBubbleBg"
                  [style.color]="configForm.value.customerBubbleText"
                  [style.border-radius]="configForm.value.bubbleRadius"
                  [style.box-shadow]="configForm.get('boxShadowMedium')?.value"
                  [style.font-size]="configForm.value.fontSizeBase"
                >
                  {{ 'theme.item.preview.user-message.example' | i18n }}
                </div>
              </div>
              <div class="message-row service">
                <span class="avatar"></span>
                <div
                  class="message service"
                  [style.background]="configForm.value.agentBubbleBg"
                  [style.color]="configForm.value.agentBubbleText"
                  [style.border-radius]="configForm.value.bubbleRadius"
                  [style.box-shadow]="configForm.get('boxShadowMedium')?.value"
                  [style.font-size]="configForm.value.fontSizeBase"
                >
                  {{ 'theme.item.preview.service-message.example' | i18n }}
                </div>
              </div>
            </div>
            <div class="chat-input" [style.background]="configForm.value.footerBg">
              <div class="input-with-action">
                <input
                  nz-input
                  class="preview-input"
                  [placeholder]="'theme.item.preview.input-placeholder' | i18n"
                  testId="servicenumber-theme-preview-input"
                />
                <button
                  nz-button
                  nzType="primary"
                  class="send-btn"
                  [style.background-color]="configForm.value.primaryColor"
                  [style.border-color]="configForm.value.primaryColor"
                  testId="servicenumber-theme-preview-send-button"
                >
                  <i nz-icon nzType="send" nzTheme="outline"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="preview-note">{{ 'theme.item.preview.note' | i18n }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
